<template>
    <div>
        <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields" :permission="permission"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "FixedIncomeContent",
        components: {CommonTable},
        data(){
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                  name: 'countryId',
                  placeholder: '国家',
                  type: 'select',
                  selectUrl: '/country/getAll',
                  selectData: [],
                },  {
                  name: 'fixedIncomeId',
                  placeholder: '投资产品ID',
                  type: 'select',
                  selectUrl: '/fixedIncome/getAll',
                  selectData: [],
                }],
                permission:{
                    add: 'fixedIncomeContent:add',
                    update: 'fixedIncomeContent:update',
                    delete: 'fixedIncomeContent:delete',
                    deleteBatch: 'fixedIncomeContent:deleteBatch'
                },
                url: {
                    get: '/fixedIncomeContent/listByCondition',
                    add: '/fixedIncomeContent/add',
                    update: '/fixedIncomeContent/update',
                    delete: '/fixedIncomeContent/delete/',
                    delete_batch: '/fixedIncomeContent/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                }, {
                  field: 'fixedIncomeId',
                  label: '理财产品',
                  selectUrl: '/fixedIncome/getAll',
                  selectData: [],
                  show: {
                    type: 'select'
                  },
                  width: '',
                }/*, {
                    field: 'content',
                    label: '内容',
                    show: true,
                    width: '',
                }*/,  {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                },{
                  field: 'countryId',
                  label: '国家',
                  selectUrl: '/country/getAll',
                  selectData: [],
                  show: {
                    type: 'select'
                  },
                  width: '',
                }, {
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加公告',
                    updateTitle: '修改公告',
                    model: [ {
                      field: 'agentId',
                      label: '代理',
                      type: 'select',
                      selectUrl: '/agent/getAll',
                      selectData: [],
                      placeholder: '请选择',
                      rules: [{
                        message: '请选择代理', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true,
                    },{
                        field: 'fixedIncomeId',
                        label: '投资产品ID',
                        type: 'select',
                        selectUrl: '/fixedIncome/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择投资产品ID', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    },{
                      field: 'countryId',
                      label: '国家ID',
                      type: 'select',
                      selectUrl: '/country/getAll',
                      selectData: [],
                      placeholder: '请选择',
                      rules: [{
                        message: '请选择国家ID', trigger: 'blur', required: true
                      }],
                      add: true,
                      update: true,
                    },{
                      field: 'content',
                      label: '内容',
                      type: 'editor',
                      placeholder: '内容',
                      rules:[{message: '请输入内容', trigger: 'blur', required: true}],
                      add: true,
                      update: true,
                    },{
                        field: 'createTime',
                        label: '时间',
                        type: 'dateTime',
                        placeholder: '请选择时间',
                        rules: [{
                            message: '请选择时间', trigger: 'blur', required: true
                        }],
                        //add: true,
                        update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
